export default __webpack_public_path__ + "static/media/fish necklace blue.3596fd33.png";